import styled from '@emotion/styled';
import Label from '~/theseus/components/Form/Label';

export default styled(Label)`
  display: flex;
  flex-wrap: wrap;
  margin: 25px 0px;
  cursor: pointer;

  & + & {
    margin-bottom: 0;
  }

  &:last-of-type {
    margin-bottom: 20px;
  }
  
  .label { 
    width: 100px;
  }
  
  & > input[type=checkbox] {
    cursor: pointer;
  }

  .error {
    margin-top: 10px;
    margin-left: 120px;
  }

  & > textarea {
    resize: vertical;
    flex-basis: 50%;
    flex-grow: 2;
  }
`;
